const capitalizeFirstLetter = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1)

export default capitalizeFirstLetter
